import clearEmptyParams from "./clearEmptyParams";
import confirm from "./confirm";

export default {
  // 注册
  async install(Vue, options) {
    Vue.use(clearEmptyParams);
    Vue.use(confirm);
  }
};



// WEBPACK FOOTER //
// ./src/plugins/index.js